import { render, staticRenderFns } from "./add-source.vue?vue&type=template&id=4ffd0780&scoped=true&"
import script from "./add-source.vue?vue&type=script&lang=js&"
export * from "./add-source.vue?vue&type=script&lang=js&"
import style0 from "./add-source.vue?vue&type=style&index=0&id=4ffd0780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd0780",
  null
  
)

export default component.exports